module.exports = __webpack_public_path__ + "img/new-label.abce381.e792aad8.png";